import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { Document } from './document'
import { ReturnDocument } from '@/domain/returns'

const { Card } = Base

interface DocumentsProps {
  returnDocuments: ReturnDocument[]
}

export const Documents: React.FC<DocumentsProps> = ({ returnDocuments }) => {
  const { t } = useTranslation()

  return (
    <Card className="h-fit p-5" id="document-card">
      <div className="mb-4 flex items-center gap-1.5">
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="200px"
          width="200px"
          xmlns="http://www.w3.org/2000/svg"
          className="size-5 text-primary-main"
        >
          <path fill="none" d="M0 0h24v24H0z"></path>
          <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zM9.41 14.42 11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01l1.41 1.41z"></path>
        </svg>
        <p className="text-sm font-semibold">
          {t('process_details_page.uploaded_docs')}
        </p>
      </div>
      <div className="mt-4 flex flex-wrap justify-center gap-4">
        {returnDocuments.map((doc, i) => {
          return <Document key={i} doc={doc} index={i} />
        })}
      </div>
    </Card>
  )
}
